module.exports = __webpack_public_path__ + "static/media/make-history.ee15c377.svg";